import axios from 'axios';
import qs from 'qs';
import { sort_ASCII } from "../util/util";
import md5 from 'js-md5'
import { Toast } from "vant";
const host = window.location.host,protocol= window.location.protocol;
let getBaseUrl= ''
// if (process.env.VUE_APP_ENV == 'test' || process.env.VUE_APP_ENV == 'development') { // 测试或开发环境
//     getBaseUrl = '//account-test.classba.cn/api/'
// }else if(process.env.VUE_APP_ENV == 'pre'){
//     getBaseUrl =  `//account-pre.classba.cn/api/`;
// }else{
//     getBaseUrl =  `//account.classba.cn/api/`;
// }
if (host.indexOf('paddl.test.classba.cn') > -1) { // 测试环境
    getBaseUrl = '//account-test.classba.cn/api/'
  } else if (host.indexOf('exp4pad-pre.classba.cn') > -1) { // 开发环境
    getBaseUrl =  `//account-pre.classba.cn/api/`;
  } else if (host.indexOf('exp4pad.classba.cn') > -1) { // 正式环境
    getBaseUrl =  `//account.classba.cn/api/`;
  } else {
    getBaseUrl = '//account-test.classba.cn/api/'
  }
axios.defaults.withCredentials=false
const service = axios.create({
    baseURL: getBaseUrl,
    withCredentials: false,
    // baseURL: `${protocol}//${host}/api`,
    timeout: 10 * 1000, // request timeout
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
})
service.interceptors.request.use(function(config) {
    if (config.params && (config.params instanceof Object) && !config.params.sign) {
        config.params["sign"] = md5(decodeURIComponent(sort_ASCII(config.params) + "yx_2020_express_dl"))
    }
    const params = config.data ? qs.parse(config.data) : {}
    if (params && !params.sign) {
        const params = qs.parse(config.data)
        config.data = qs.stringify({
            ...params,
            sign: md5(decodeURIComponent(sort_ASCII(params) + "yx_2020_express_dl"))
        })
    }
    return Promise.resolve(config);
}, function(error) {
    Toast('系统开小差了，刷新后再试')
    return Promise.reject(error);
})

service.interceptors.response.use(function(response) {
    let retData
    if (response.data.code < 0) {
        retData = {
            ...response.data,
            message: '系统开小差了，刷新后再试'
        }
    } else {
        retData = {
            ...response.data
        }
    }
    return Promise.resolve(retData);
}, function (error) {
    Toast('系统开小差了，刷新后再试')
    return Promise.reject(error);
})

class AccountAxios{
    constructor(options = {}) {
        this.options = options;
    }
    request(options) {
        return service.request(options);
    }
    get(url, options = {}) {
        return this.request({
            url: url,
            params: {
                ...options
            }
        })
    }
    post(url, data, options = {}) {
        if (data instanceof Object) {
            data = qs.stringify(data);
        }
        return this.request({
            method: 'post',
            url,
            data,
            ...options
        });
    }
}
const instanceAxios = new AccountAxios();
export const request = instanceAxios.request.bind(instanceAxios);
export const get = instanceAxios.get.bind(instanceAxios);
export const post = instanceAxios.post.bind(instanceAxios);

